import React from 'react'
import { Image, useColorModeValue } from '@chakra-ui/react'
import LogoLight from '../../images/logo-light.svg'
import LogoDark from '../../images/logo-dark.svg'

export const Logo = ({ ...props }) => {
  const logoSrc = useColorModeValue(LogoLight, LogoDark)
  return <Image src={logoSrc} boxSize="68px" {...props} />
}
